import { AV } from '../../media/meeting/av';
import { Net } from '../../net/net';
import { copyInvite } from '../core/entry';
import { chatOpen, toggleChat } from './chat';
import { openShare } from './board';
import { addKeyGuard, onEscape } from './esc';
import { closeFeedback, isFeedbackOpen, openFeedback } from '../core/feedback';
import { usageState } from './usage';
import { GROUP } from '../../../3-store/meeting/links';
import { ME } from '../../../3-store/core/me';
import { currentShare, toggleHand } from '../../../2-controllers/meeting/share';
import { amTeacher, handRows, lockReason, teacherHere, toggleGrant } from '../../../2-controllers/meeting/classroom';
import { CLASS } from '../../../3-store/meeting/classroom';
import { isMeeting, isNear } from '../../../../shared/world/links';

const G = (window as any).G;
const PLACE: Record<string, string> = { town: '풀잎 마을', school: '얼라 비즈니스 스쿨', office: '퍼스트파이브', starbox: '스타박스' };   // 장소 아이디 → 화면에 쓰는 이름 (town.js의 name과 같다)

// 도구 막대(#meet): 위 줄은 채팅·초대·음악·전체 화면·사용량, 아래 줄은 마이크·카메라·배경 흐림·화면 공유·손 들기와 같이 통화 중인 인원. 모양은 index.html.
// 마을·건물 안에 있는 동안 보이고(음성 통화는 어디서나 된다), 서버에 연결되어 있을 때만 채팅·초대·사용량·통화 줄이 있다.
// 단추가 포커스를 가져가면 게임 키(Space 등)가 단추를 누르므로 마우스 누름은 막는다.
const $ = (id: string) => document.getElementById(id) as HTMLElement;
let msgT: any = 0;
const canShare = !!(navigator.mediaDevices && (navigator.mediaDevices as any).getDisplayMedia);   // 휴대폰 브라우저 등에는 없다
export const note = (t: string, ms = 5000) => { const m = $('avMsg'); m.textContent = t; m.hidden = !t; clearTimeout(msgT); if (t) msgT = setTimeout(() => { m.hidden = true; }, ms); };

export function initToolbar() {
  const mic = $('bMic'), cam = $('bCam'), blur = $('bBlur'), share = $('bShare'), hand = $('bHand');
  for (const b of [mic, cam, blur, share, hand]) b.addEventListener('mousedown', (e) => e.preventDefault());
  mic.onclick = async () => { if (lockReason('mic')) return; if (!(await AV.setMic(!AV.state.mic)) && !AV.state.mic) note('마이크를 켤 수 없어요. 브라우저의 권한을 확인해 주세요'); refresh(); };
  cam.onclick = async () => { if (lockReason('cam')) return; if (!(await AV.setCam(!AV.state.cam)) && !AV.state.cam) note(AV.error || '카메라를 켤 수 없어요. 브라우저의 권한을 확인해 주세요'); refresh(); };
  blur.onclick = () => { AV.setBlur(!AV.blur); refresh(); };
  // 화면 공유: 모임마다 한 사람. 다른 사람이 공유 중이면 내 공유는 시작하지 않고(서버도 거절한다) 그 화면을 크게 본다, 내가 공유 중이면 끄는 단추가 된다
  share.onclick = async () => {
    const sh = currentShare();
    if (sh && !sh.mine) return openShare();
    if (lockReason('share')) return;
    if (!(await AV.setShare(!AV.state.share)) && !AV.state.share && !sh) note('화면 공유를 시작할 수 없어요');
    refresh();
  };
  hand.onclick = () => { toggleHand(); refresh(); };
  // 위 줄: 채팅 · 초대 링크 · 음악 · 전체 화면 · 사용량(창은 usage.ts)
  const util = ['bChatT', 'bLink', 'bMusic', 'bFull', 'bUse', 'bFb'].map($);
  for (const b of util) b.addEventListener('mousedown', (e) => e.preventDefault());
  $('bChatT').onclick = () => { toggleChat(); refresh(); };
  $('bLink').onclick = () => copyInvite(() => note('초대 링크를 복사했습니다. 친구에게 보내세요'), () => note(location.href, 9000));
  $('bMusic').onclick = () => { G.audio.toggleMute(); refresh(); };
  // 피드백 창(창은 screen/core/feedback.ts): 열려 있는 동안 게임 키를 막고, Esc는 이 창만 닫는다. core는 meeting(esc.ts)을 가져올 수 없어 여기서 잇는다
  addKeyGuard(isFeedbackOpen);
  onEscape({ isOpen: isFeedbackOpen, close: closeFeedback });
  $('bFb').onclick = () => openFeedback({ name: G.save.data.name || '', place: PLACE[ME.room || ''] || '', canvas: $('game') });
  const fsEl = () => document.fullscreenElement || (document as any).webkitFullscreenElement, root = document.documentElement as any;
  const canFull = !!(document.fullscreenEnabled || (document as any).webkitFullscreenEnabled) && !!(root.requestFullscreen || root.webkitRequestFullscreen);   // 아이폰 사파리 등에는 없다
  $('bFull').hidden = !canFull;
  $('bFull').onclick = () => { try { fsEl() ? (document.exitFullscreen || (document as any).webkitExitFullscreen).call(document) : Promise.resolve((root.requestFullscreen || root.webkitRequestFullscreen).call(root)).catch(() => note('전체 화면을 켤 수 없어요')); } catch (e) { note('전체 화면을 켤 수 없어요'); } };
  ['fullscreenchange', 'webkitfullscreenchange'].forEach((ev) => document.addEventListener(ev, () => { last = ''; refresh(); }));
  AV.onChange = refresh;
}

// 단추 모양을 지금 상태에 맞춘다. 프레임마다 부른다(바뀐 것만 DOM을 건드린다)
let last = '';
export function refresh() {
  const sh = currentShare(), shKey = sh ? (sh.mine ? 'me' : sh.id + sh.name) : '';
  const online = Net.online, inPlace = ME.room !== null, st = usageState(), full = !!(document.fullscreenElement || (document as any).webkitFullscreenElement);
  const rows = handRows(), lock = { mic: lockReason('mic'), cam: lockReason('cam'), share: lockReason('share') }, granted = CLASS.granted && teacherHere();
  const key = [lock.mic, lock.cam, lock.share, amTeacher(), teacherHere(), granted, rows.map((r) => r.id + r.name + r.granted).join(','), GROUP.key, GROUP.n, AV.state.mic, AV.state.cam, AV.blur, AV.loading, AV.error, AV.state.share, shKey, ME.hand, online, inPlace, chatOpen(), G.audio.muted, st, full].join('|');
  if (key === last) return;
  last = key;
  const meet = $('meet'), here = GROUP.key !== null;
  meet.hidden = !inPlace;
  $('avBar').hidden = !here;
  for (const id of ['bChatT', 'bLink', 'bUse', 'bFb']) $(id).hidden = !online;
  $('bChatT').classList.toggle('on', chatOpen());
  $('bMusic').classList.toggle('on', !G.audio.muted); $('bMusic').textContent = G.audio.muted ? '음악 꺼짐' : '음악';
  $('bFull').classList.toggle('on', full); $('bUse').dataset.st = st;
  $('bMic').classList.toggle('on', AV.state.mic);
  $('bCam').classList.toggle('on', AV.state.cam);
  $('bBlur').classList.toggle('on', AV.blur);
  // 강사가 있는 교실: 말할 자격이 없는 종류는 잠그고 이유를 단추에 쓴다 (강사는 셋 다, 발언권 학생은 마이크·화면 공유, 나머지는 없음)
  lockBtn('bMic', '마이크', lock.mic); lockBtn('bCam', '카메라', lock.cam, AV.loading);
  $('bShare').hidden = !isMeeting(GROUP.key) || !canShare; $('bHand').hidden = !isMeeting(GROUP.key) || amTeacher() || granted;   // 강사는 손을 들지 않고, 발언권을 받은 학생도 단추가 없다   // 화면 공유·손들기는 테이블·학교 모임에서만 (가까운 사람끼리의 음성에는 없다)
  const other = !!sh && !sh.mine;
  $('bShare').classList.toggle('on', !!sh && sh.mine);
  $('bShare').classList.toggle('view', other);
  lockBtn('bShare', sh && sh.mine ? '공유 끄기' : other ? `공유 중: ${sh!.name} · 크게 보기` : '화면 공유', sh && sh.mine || other ? '' : lock.share);   // 남의 공유는 말할 자격과 상관없이 볼 수 있다
  $('bHand').classList.toggle('on', ME.hand);
  $('avWho').textContent = !here ? '' : isNear(GROUP.key) ? `근처 ${GROUP.n}명` : `모임 ${GROUP.n}명` + (amTeacher() ? ' · 강사' : granted ? ' · 발언권' : teacherHere() ? ' · 강사 수업' : '');
  paintHands(rows);
  if (AV.error) note(AV.error, 9000);
}

// 잠긴 단추: 이유를 이름 뒤에 붙이고 누를 수 없게 한다 (loading은 카메라 흐림 준비 중)
function lockBtn(id: string, label: string, reason: string, loading = false) {
  const b = $(id) as HTMLButtonElement;
  b.disabled = !!reason || loading; b.classList.toggle('lock', !!reason);
  b.textContent = reason ? `${label} · ${reason}` : label; b.title = reason ? `강사가 있는 수업에서는 ${reason === '강사만' ? '강사만 쓸 수 있어요' : '강사에게 발언권을 받아야 해요'}` : '';
}
// 강사 화면의 목록: 손 든 학생(든 순서)과 발언권을 가진 학생. 이름 옆 단추로 발언권을 주고 거둔다
function paintHands(rows: { id: string; name: string; granted: boolean }[]) {
  const box = $('hands');
  box.hidden = !amTeacher();
  box.replaceChildren();
  const head = document.createElement('div'); head.className = 'hh'; head.textContent = rows.length ? `손 든 학생 ${rows.filter((r) => !r.granted).length}명` : '손 든 학생이 없어요'; box.append(head);
  for (const r of rows) {
    const row = document.createElement('div'), nm = document.createElement('span'), b = document.createElement('button');
    row.className = 'hr' + (r.granted ? ' gr' : ''); nm.textContent = r.granted ? `${r.name} · 발언 중` : r.name;
    b.type = 'button'; b.tabIndex = -1; b.textContent = r.granted ? '회수' : '발언권 주기'; b.dataset.id = r.id;
    b.addEventListener('mousedown', (e) => e.preventDefault()); b.onclick = () => toggleGrant(r.id);
    row.append(nm, b); box.append(row);
  }
}

// 영상 줄과 도구 막대는 게임 화면(캔버스) 오른쪽 위에 맞춘다: 캔버스 상자를 CSS 변수로 알린다
let box = '';
export function layout() {
  const r = ($('game') as HTMLElement).getBoundingClientRect(), k = [r.left, r.top, r.width, r.height].map(Math.round).join(',');
  if (k === box) return;
  box = k;
  const st = document.documentElement.style;
  st.setProperty('--cv-l', Math.round(r.left) + 'px'); st.setProperty('--cv-t', Math.round(r.top) + 'px');
  st.setProperty('--cv-w', Math.round(r.width) + 'px'); st.setProperty('--cv-h', Math.round(r.height) + 'px');
}
